
(function() {
  function injectAutoplayVideo() {
    if (document.querySelector('.seulne-injected-video')) return;
    
    var carousel = document.querySelector('.product-gallery__carousel');
    if (!carousel) return;
    
    var firstSlide = carousel.querySelector('.product-gallery__media');
    if (!firstSlide) return;
    
    // Create new gallery slide with autoplay video
    var slide = document.createElement('div');
    slide.className = 'product-gallery__media snap-center seulne-injected-video';
    slide.setAttribute('data-media-type', 'video');
    slide.innerHTML = '<video autoplay muted loop playsinline webkit-playsinline preload="auto" style="width:100%;height:100%;object-fit:cover;display:block;background:#2C2420;" src="https://cdn.shopify.com/videos/c/o/v/6d7efc3664ac463ca02afdfda8d1934a.mp4"></video>';
    
    // Insert as 2nd item (after hero)
    var secondSlide = carousel.children[1];
    if (secondSlide) {
      carousel.insertBefore(slide, secondSlide);
    } else {
      carousel.appendChild(slide);
    }
    
    // Add thumbnail for the injected video
    var thumbScroller = document.querySelector('product-gallery-navigation');
    if (thumbScroller) {
      var firstThumb = thumbScroller.querySelector('.product-gallery__thumbnail');
      if (firstThumb) {
        var newThumb = document.createElement('div');
        newThumb.className = 'product-gallery__thumbnail seulne-video-thumb';
        newThumb.style.cssText = 'background:#2C2420;border-radius:4px;cursor:pointer;overflow:hidden;aspect-ratio:1;display:flex;align-items:center;justify-content:center;';
        newThumb.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="white"><polygon points="5,3 19,12 5,21"/></svg>';
        
        newThumb.addEventListener('click', function() {
          slide.scrollIntoView({behavior:"smooth",block:"nearest",inline:"center"});
        });
        
        var secondThumb = thumbScroller.children[1];
        if (secondThumb) {
          thumbScroller.insertBefore(newThumb, secondThumb);
        }
      }
    }
    
    // Play video
    var video = slide.querySelector('video');
    
    function tryPlay() {
      if (video.readyState >= 2 && video.paused) {
        video.play().catch(function(){});
      }
    }
    
    video.addEventListener('canplay', tryPlay);
    video.addEventListener('loadeddata', tryPlay);
    
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) tryPlay();
      });
    }, {rootMargin: '300px', threshold: 0.1});
    obs.observe(slide);
    
    var retries = 0;
    var interval = setInterval(function() {
      retries++;
      tryPlay();
      if (!video.paused || retries > 30) clearInterval(interval);
    }, 500);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectAutoplayVideo);
  } else {
    injectAutoplayVideo();
  }
  setTimeout(injectAutoplayVideo, 500);
  setTimeout(injectAutoplayVideo, 1500);
})();
